import { IUser } from '@common/interfaces/user'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { ADD_OR_REMOVE_MANAGER_REQUEST } from '../clientInfo/actions'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer([actions.prefix]),
  list: createLoadingDataReducer<{ data: IUser[] }>(
    [actions.LIST_REQUEST],
    [
      actions.CREATE_REQUEST,
      actions.UPDATE_REQUEST,
      actions.DELETE_REQUEST,
      ADD_OR_REMOVE_MANAGER_REQUEST,
      actions.INVITE_REQUEST,
    ],
    true,
    undefined, // resetActionTypes
    true, // withMergeOnUpdate - enable merging objects on update
  ),
})
